import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "@/App";
import { Provider } from "react-redux";
import { store } from "./store";
import { ErrorBoundary } from "@/app/shared/error-boundaries";
import "./index.css";
import { AppBootstrap } from "./AppBootstrap";

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <BrowserRouter>
      <ErrorBoundary>
        <AppBootstrap>
          <App />
        </AppBootstrap>
      </ErrorBoundary>
    </BrowserRouter>
  </Provider>
);
